import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageVariables } from '../../shared/constants/app.enum';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  set(key: StorageVariables, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: StorageVariables): any {
    const item = localStorage.getItem(key);

    if (!item) return null;

    try {
      return JSON.parse(item);
    } catch {
      this.remove(key);
      return null;
    }
  }

  remove(key: StorageVariables): void {
    localStorage.removeItem(key);
  }

  clear(): Observable<boolean> {
    return new Observable(observer => {
      localStorage.clear();
      observer.next(true);
    });
  }

  hasItem(key: StorageVariables): boolean {
    return !!localStorage.getItem(key);
  }

  setSessionItem(key: StorageVariables, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getSessionItem(key: StorageVariables): any {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  removeSessionItem(key: StorageVariables): void {
    sessionStorage.removeItem(key);
  }

  clearSession(): void {
    sessionStorage.clear();
  }
}
